import React from 'react';
import AutoSuggest from 'react-autosuggest';
import {TextField} from "./index";
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

function renderInputComponent(inputProps) {
  const { inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
      }}
      {...other}
    />
  );
}

const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
        display: 'inline-block'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        //left: 0,
        //right: 0,
        backgroundColor: "black",
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
});

class AutoComplete extends React.PureComponent {
    constructor (props) {
        super(props);
        this.state = {
        filteredSuggestions: [],
        };
    }

    handleFetch = ({ value }) => {
        const { suggestions } = this.props;
        const filteredSuggestions = suggestions.filter(
            (suggestion) => suggestion[this.props.completeField].toLowerCase().startsWith(value.toLowerCase())
        );
        this.setState({ filteredSuggestions });
    };

  handleClear = () => {
    this.setState({ filteredSuggestions: [] });
  };

  handleGetSuggestion = (props) => {
    return props[this.props.completeField];
  };

  handleSuggestionHighlighted = ({ suggestion }) => {
    this.setState({ highlightedSuggestion: suggestion });
  };

  // renderSuggestion = (props) => {
  //   return (
  //     <span>{props[this.props.completeField]}</span>
  //   );
  // };

  renderSuggestion = (suggestion) => {
      return (
        <MenuItem component="div">
          <div>
            <strong style={{ fontWeight: 300 }}>
              {suggestion[this.props.completeField]}
            </strong>
          </div>
        </MenuItem>
      );
    };

  handleSuggestionSelected = (event, { suggestionValue, method }) => {
    const { input } = this.props;
    input.onChange(suggestionValue);
    if (method === 'enter') {
      event.preventDefault();
    }
  };

  render () {

    const { input, label, classes } = this.props;
    const { filteredSuggestions } = this.state;
    return (
      <AutoSuggest
        renderInputComponent={renderInputComponent}
        suggestions={filteredSuggestions}
        onSuggestionsFetchRequested={this.handleFetch}
        onSuggestionsClearRequested={this.handleClear}
        getSuggestionValue={this.handleGetSuggestion}
        renderSuggestion={this.renderSuggestion}
        onSuggestionHighlighted={this.handleSuggestionHighlighted}
        onSuggestionSelected={this.handleSuggestionSelected}
        inputProps={{
            ...input,
            label: label,
        }}
        theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
        renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}
      />
    );
  }
}

export default withStyles(styles)(AutoComplete)


// WEBPACK FOOTER //
// ./src/common/FormComponents/AutoComplete.js